import { getTrackedUtmParams } from "./getTrackedUtmParams";

export const SPARKS_SIGNUP_URL = "https://home.classdojo.com/#/sparks-signup";

export const getSparksSignupUrl = (): string => {
  const utmParams = getTrackedUtmParams();
  if (!utmParams) return SPARKS_SIGNUP_URL;

  const qs = new URLSearchParams(utmParams).toString();
  if (!qs) return SPARKS_SIGNUP_URL;

  const hashIndex = SPARKS_SIGNUP_URL.indexOf("#");
  return `${SPARKS_SIGNUP_URL.slice(0, hashIndex)}?${qs}${SPARKS_SIGNUP_URL.slice(hashIndex)}`;
};
